import { normalize } from 'normalizr'
import { all } from 'redux-saga/effects'
import { customerGiftIssuedEntity } from 'redux/entities'
import pagaSaga from 'redux/pagination/sagas'
import actions from './actions'

const norm = data => normalize(data?.customer_gifts ?? [], [customerGiftIssuedEntity])

export default function* rootSaga() {
  yield all([...pagaSaga([actions.LIST_CUSTOMER_GIFTS_ISSUED, actions.LIST_CUSTOMER_GIFTS_ISSUED_NEXT], norm)])
}
